import __request__ from "routing/request";
export function value(dashboardId, widgetId, JSONbody, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.report/widgets/${dashboardId}/${widgetId}/value`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
